import { render, staticRenderFns } from "./VxCard.vue?vue&type=template&id=79c6cea6"
import script from "./VxCard.vue?vue&type=script&lang=js"
export * from "./VxCard.vue?vue&type=script&lang=js"
import style0 from "./VxCard.vue?vue&type=style&index=0&id=79c6cea6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\site-teste\\flash-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79c6cea6')) {
      api.createRecord('79c6cea6', component.options)
    } else {
      api.reload('79c6cea6', component.options)
    }
    module.hot.accept("./VxCard.vue?vue&type=template&id=79c6cea6", function () {
      api.rerender('79c6cea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Resources/js/src/components/vx-card/VxCard.vue"
export default component.exports